// Shared constants for Electronic Trade Documents components.

/** Fake documentId used for the USMCA virtual row in the document list. */
export const USMCA_VIRTUAL_DOC_ID = 'usmca-virtual';

/** ID used for the USMCA item inside the Quick Actions panel. */
export const USMCA_QUICK_ACTION_ID = 'usmca-auto';
